import React, { useState } from 'react';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const BETA_TOAST_COOKIE = 'sleep_scorer_beta_toast_closed';
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

const hasDismissedToast = () => {
  if (typeof document === 'undefined') {
    return false;
  }

  return document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .some((cookie) => cookie.startsWith(`${BETA_TOAST_COOKIE}=true`));
};

const dismissToastCookie = () => {
  if (typeof document === 'undefined') {
    return;
  }

  document.cookie = `${BETA_TOAST_COOKIE}=true; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; samesite=lax`;
};

const BetaToast = () => {
  const [isVisible, setIsVisible] = useState(() => !hasDismissedToast());

  const handleDismiss = () => {
    dismissToastCookie();
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-[70] max-w-sm rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 shadow-lg dark:border-amber-700/60 dark:bg-amber-900/80">
      <div className="flex items-start gap-3">
        <div className="flex-1">
          <p className="text-sm font-semibold text-amber-900 dark:text-amber-100">SleepScorer is in beta</p>
          <p className="mt-1 text-xs text-amber-800 dark:text-amber-200">
            SleepScorer is currently in the beta testing phase, so some features and results may change as we continue to validate and improve the platform.
          </p>
        </div>
        <button
          type="button"
          onClick={handleDismiss}
          className="rounded p-1 text-amber-700 transition hover:bg-amber-100 hover:text-amber-900 dark:text-amber-200 dark:hover:bg-amber-800/60 dark:hover:text-amber-50"
          aria-label="Close beta notification"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>
    </div>
  );
};

export default BetaToast;